import React from "react";
import PhotoLibrary from "../../components/photolibrary";

const MyndaAlbum = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2] px-4 py-10">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center mb-8">
          <a href="/pantanir" className="text-stone-400 hover:text-[#C29979] font-serif text-sm transition-colors mr-auto">← Til baka</a>
          <div className="text-center flex-1">
            <h1 className="text-2xl md:text-3xl font-serif text-stone-900 mb-1">Mynda Albúm</h1>
            <div className="w-16 h-0.5 bg-[#C29979] mx-auto"></div>
          </div>
          <div className="mr-auto opacity-0 text-sm">← Til baka</div>
        </div>
        <PhotoLibrary />
      </div>
    </div>
  );
}

export default MyndaAlbum;
